export default (props) => <div  {...props} style={{...styles, ...props?.style}} />

const styles = {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: 10
}